import { UIFilters } from './ExploreTable/types'

const existence = (value: unknown) => {
  return value !== undefined ? 1 : 0
}

const filterCounter: {
  [TKey in keyof UIFilters]-?: (value: UIFilters[TKey]) => number
} = {
  locations: (val) => (val?.length ? 1 : 0),
  isActive: existence,
  religiousAffiliation: (val) => (val?.length ? 1 : 0),
  isTitle1Eligible: existence,
  schoolType: existence,
  virtual: existence,
  title1Program: existence,
  classSize: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctFreeReducedLunch: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  visitRange: (val) => existence(val?.type),
  text: (val) => (val?.length ? 1 : 0),
} as const

const getFilterCount = (filters: UIFilters): number => {
  let count = 0
  for (const key in filterCounter) {
    const keyName = key as keyof typeof filterCounter
    const fn = filterCounter[keyName] as (value: UIFilters[typeof keyName]) => number
    count += fn(filters[keyName])
  }
  return count
}

export default getFilterCount
